<div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-black/75 transition-opacity" (click)="close()"></div>
    <div class="fixed inset-0 z-50 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center text-center md:items-center">
            <div
                class="relative transform lg:min-h-[600px] min-h-[80vh] overflow-hidden overscroll-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all md:my-8 md:w-full md:max-w-3xl md:py-3 md:px-3">
                <div class="absolute right-0 top-0 pr-4 pt-4">
                    <button
                        type="button"
                        (click)="close()"
                        class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                        <span class="sr-only">Close</span>
                        <svg
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
